import { I18nLang, IBaseDictItem, IBaseDrugRna } from '@patsnap/synapse_common_interface'
import { EMPTY_PLACEHOLDER } from '@pharmsnap/shared/src/constants'
import { getDicItemName } from '@pharmsnap/shared/src/utils'
import { defineComponent, PropType } from '@vue/composition-api'
import { isArray } from 'lodash'

function drugRnaDictFieldComBuilder(field: keyof IBaseDrugRna, comName: string) {
  return defineComponent({
    name: comName,
    props: {
      data: {
        type: Object as PropType<IBaseDrugRna>,
        required: true,
      },
      locale: {
        type: String as PropType<I18nLang>,
        required: true,
      },
    },
    setup(props) {
      return () => {
        if (!props.data[field]) return <span>{EMPTY_PLACEHOLDER}</span>

        const fieldData = props.data[field] as IBaseDictItem | IBaseDictItem[]

        if (isArray(fieldData)) {
          if (fieldData.length === 0) return <span>{EMPTY_PLACEHOLDER}</span>
          return <span>{fieldData.map((item) => getDicItemName(item, props.locale)).join(', ')}</span>
        }

        return <span>{getDicItemName(fieldData as IBaseDictItem, props.locale)}</span>
      }
    },
  })
}

// 遗传物质
export const BDrugRnaGeneticMaterial = drugRnaDictFieldComBuilder('genetic_material_view', 'BDrugRnaGeneticMaterial')

// 递送系统
export const BDrugRnaDeliverySystem = drugRnaDictFieldComBuilder('delivery_system_view', 'BDrugRnaDeliverySystem')

// 靶向组织
export const BDrugRnaTargetTissues = drugRnaDictFieldComBuilder('targeted_tissue_view', 'BDrugRnaTargetTissues')

// 识别区域
export const BDrugRnaPairedRegion = drugRnaDictFieldComBuilder('paired_region_view', 'BDrugRnaRecognitionRegion')

// 调控机制
export const BDrugRnaRegulationMechanism = drugRnaDictFieldComBuilder('regulation_type_view', 'BDrugRnaRegulationMechanism')

// 技术平台
export const BDrugRnaTechPlatform = drugRnaDictFieldComBuilder('tech_platform_view', 'BDrugRnaTechPlatform')
